import { useQuery } from '@tanstack/react-query';
import { axios } from '@/lib/axios/axios';
import { QueryConfig } from '@/lib/react-query/react-query';
import { MESSAGING_API_BASE, messagingQueryKeys } from '../config';
import { ChannelMemberResponse } from '../types/backend';

const getMembers = async (
  channelId: number
): Promise<ChannelMemberResponse[]> => {
  return axios.get(`${MESSAGING_API_BASE}/channels/${channelId}/members`);
};

type QueryFnType = typeof getMembers;

type UseMembersOptions = {
  channelId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useMembers = ({ channelId, config }: UseMembersOptions) => {
  return useQuery({
    queryKey: [...messagingQueryKeys.members(channelId)],
    queryFn: () => getMembers(channelId),
    staleTime: Infinity,
    enabled: channelId > 0,
    ...config,
  });
};
